// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2FV7p","header":"PatientBlock_header__10JwS","label":"PatientBlock_label__1IA4J","option":"PatientBlock_option__39RNt"};